
export const cssColor = {
    ALL: "bg-slate-200 text-slate-600 border-slate-300",
    URGENT: "bg-red-100 text-red-600 border-red-300",
    IMPORTANT: "bg-yellow-100 text-yellow-600 border-yellow-300",
    NORMALE: "bg-lime-100 text-lime-600 border-lime-300",
    MEMO: "bg-sky-100 text-sky-600 border-sky-300",
    OPEN: "bg-teal-100 text-teal-600 border-teal-300",
    ONGOING: "bg-purple-100 text-purple-600 border-purple-300",
    CLOSED: "bg-gray-200 text-gray-600 border-gray-300",
    PENDING: "bg-amber-100 text-amber-600 border-amber-300",
    UNREALIZABLE: "bg-pink-200 text-pink-600 border-pink-300",
}

export const htmlColor = {
    ALL: "oklch(70.4% 0.04 256.788)",
    URGENT: "oklch(70.4% 0.191 22.216)",
    IMPORTANT: "oklch(85.2% 0.199 91.936)",
    NORMALE: "oklch(84.1% 0.238 128.85)",
    MEMO: "oklch(74.6% 0.16 232.661)",
    OPEN: "oklch(77.7% 0.152 181.912)",
    ONGOING: "oklch(71.4% 0.203 305.504)",
    CLOSED: "oklch(70.7% 0.022 261.325)",
    PENDING: "oklch(82.8% 0.189 84.429)",
    UNREALIZABLE: "oklch(71.8% 0.202 349.761)",
}
